import React from 'react'

import { TextColorType } from '@ui/design-system/colors/colors'
import { IconFCType, IconProps } from '@ui/icons/types'

export interface ValidIconProps extends Omit<IconProps, 'color' | 'secondaryColor'> {
  color?: string
  secondaryColor?: string
}

export const createValidIcon = <P = {},>(
  Component: React.FC<ValidIconProps & P>
): IconFCType<P> => {
  const WrappedIcon: React.FC<IconProps & P> = (props) => {
    const color = processColor('text-med-em', props.color)
    const secondaryColor = processColor('text-white', props.secondaryColor)
    const size = props.size ?? 24

    const componentProps: ValidIconProps & P = {
      ...(props as Omit<IconProps, 'color' | 'secondaryColor'> & P),
      color,
      size,
      secondaryColor,
    }

    return React.createElement(Component, componentProps)
  }

  return Object.assign(WrappedIcon, { __isValidIcon: true as const })
}

const processColor = (fallback: TextColorType, color?: TextColorType): string => {
  if (color && color === 'currentColor') {
    return 'currentColor'
  }

  if (color && isNonCurrentColor(color)) {
    return `var(--${color})`
  }

  return `var(--${fallback})`
}

const isNonCurrentColor = (
  color: TextColorType
): color is Exclude<TextColorType, 'currentColor'> => {
  return color !== 'currentColor'
}
